<template>
  <div>
    <ul class="table__header">
      <li>Rider</li>
      <li class="hidden-mob">Horse</li>
      <li class="cutout_value">Cutout</li>
      <li />
    </ul>
    <ul
      v-for="cutout in cutouts"
      :key="cutout.id"
      class="table__body"
      :class="{ is_winner: cutout.isWinner }"
    >
      <li>
        {{ cutout.rider }}
        <div class="display-mob">Horse: {{ cutout.horse }}</div>
      </li>
      <li class="hidden-mob">{{ cutout.horse }}</li>
      <li class="cutout_value">{{ cutout.cutoutScore }}</li>
      <li class="actions">
        <span v-if="cutout.isWinner">Winner</span>
        <a
          v-else-if="!hasWinner"
          href="#"
          class="btn-make-winner"
          @click.prevent="makeWinner(cutout)"
        >
          Make winner
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

export default defineComponent({
  name: 'PrizesCutoutsTable',
  props: {
    cutouts: { type: Array, default: () => [] },
    isFinalRound: { type: Boolean, default: false }
  },
  emits: ['make-winner'],
  setup(props, ctx) {
    const hasWinner = computed(() => props.cutouts.some(c => c.isWinner))

    function makeWinner(cutout) {
      ctx.emit('make-winner', cutout)
    }

    return { hasWinner, makeWinner }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Prizes/PrizesCutoutsTable.vue